import { IOffer } from '../../offer';

export type TOfferListingType = 'extended' | 'list';

export function isExtended(offer: IOffer) {
  return offer.extensionLabels && offer.extensionLabels.length;
}

export function splitVariants(variants?: string): string[] {
  if (!variants) {
    return [];
  }

  return variants.split('/');
}
export function getExtendedOfferEventExtra(offer: IOffer, source?: string) {
  const extensionLabels = offer.extensionLabels;

  return extensionLabels?.length
    ? {
        extra: {
          extended_type: extensionLabels.map(({ labelType }) => labelType),
          source,
        },
      }
    : source
      ? { extra: { source } }
      : {};
}

export function getOfferListingType(offer: IOffer): TOfferListingType {
  return isExtended(offer) ? 'extended' : 'list';
}
